export enum ProcessActivityStatus {
    complete = 'complete',
    draft = 'draft',
}
